// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__0zWyo","modal_title":"ModalWindow_modal_title__aEuCC","modal_text":"ModalWindow_modal_text__eND0m"};